import debugLog from '@/debug-log-script-name.js'

$(function() {
  const $menu = $('#help-menu')
  debugLog($menu, 'help-menu.js') // DEBUG
  function closeMenu() {
    $menu
      .removeClass('active')
      .find('li')
      .removeClass('active')
  }

  $('body')
    .on('click.help-menu', '[data-toggle="help-menu"]', function(e) {
      if ($menu.hasClass('active')) {
        closeMenu()
      } else {
        $menu.addClass('active')
      }

      e.preventDefault()
    })
    .on('click', function(e) {
      // If not clicked on menu or menu toggle, close the menu
      if (
        $(e.target).closest($menu).length === 0 &&
        $(e.target).closest('[data-toggle="help-menu"]').length === 0 &&
        $menu.hasClass('active')
      ) {
        closeMenu()
      }
    })

  // Toggle submenu
  $menu.on('click.help-menu', '[data-toggle="sub-menu"]', function(e) {
    $(this)
      .parent('li')
      .toggleClass('active')
    e.preventDefault()
  })
})
